// The server answers a refused settings save with a bare string, or a { code } /
// { error } object; a non-Master gets a 403 with no code.
function saveErrorCode(err: any): string {
  const response = err?.response;
  if (response?.status === 403) return "FORBIDDEN";
  const body = response?.data;
  return String(body?.code || body?.error || body || "");
}

/**
 * The text key to show for a failed save: the page's own message for the
 * server's code, else "only a Master can change this" for a 403, else the
 * general "couldn't save".
 */
export function saveErrorKey(
  err: unknown,
  keysByCode: Record<string, string>
): string {
  const code = saveErrorCode(err);
  if (keysByCode[code]) return keysByCode[code];
  return code === "FORBIDDEN" ? "settings_master_only" : "settings_save_failed";
}
